import request from './request'
import Servers from '@config'

export default {
  // 获取发票列表
  fetchInvoiceList: request.get(Servers.oss + '/mall/new-invoice/list'),

  // 获取发票详情
  fetchInvoiceDetail: request.get(Servers.oss + '/mall/new-invoice/detail'),

  // 我已处理
  processInvoiceRed: request.post(Servers.oss + '/mall/new-invoice/process-red'),

  // 我已确认
  confirmInvoiceRed: request.post(Servers.oss + '/mall/new-invoice/confirm-red'),

  // 申请开票
  applyInvoice: request.post(Servers.oss + '/mall/new-invoice/apply'),

  // 下载形式发票
  downloadFormalInvoice: ({ order_id }) => {
    window.open(Servers.oss + `/mall/invoice/formal-invoice?order_id=${order_id}`, '_blank')
  },

  // 换票重开
  changeBillReopen: request.post(Servers.oss + '/mall/new-invoice/change-bill'),

  // 取消重开
  cancelReopen: request.post(Servers.oss + '/mall/new-invoice/cancel-change-bill'),

  // 下载代付款证明模板
  downloadPaymentProof: ({ order_id }) => {
    window.open(Servers.oss + `/mall/new-invoice/down-payment-proof?order_id=${order_id}`, '_blank')
  },
}